import * as React from 'react';

interface IFlosIcon extends React.HTMLAttributes<HTMLElement> {
  shape: string;
  size?: string;
  class?: string;
  style?: any;
  dir?: string;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'flos-icon': IFlosIcon;
    }
  }
}

interface SvgIconProps {
  iconHref: string;
  size?: string;
  className?: string;
  dir?: string;
}

/**
 * `SvgIcon` is used to display the svg icon as listed in [styleguide](https://styleguide.topdanmark.dk/components/detail/flos-icons.html)
 */
export const SvgIcon: React.FC<SvgIconProps> = ({
  size = '60',
  iconHref = 'error',
  className = '',
  dir = '',
}): JSX.Element => {
  let iconSize;
  switch (size) {
    case 'large':
      iconSize = '80';
      break;
    case 'medium':
      iconSize = '60';
      break;
    case 'small':
      iconSize = '40';
      break;
    case 'xsmall':
      iconSize = '20';
      break;
    default:
      iconSize = size;
  }
  return <flos-icon class={className} size={iconSize} shape={iconHref} dir={dir} />;
};
